import Panzoom, * as gamePanzoom from "./game-panzoom"
import Modal from "./modal"
import Game from "./game"

const mapContainer = document.querySelector("#js-panzoom-main-menu")
const pinsList = document.querySelectorAll("[data-pz-map-pin]")
const closeModalButtons = document.querySelectorAll("[data-close-modal]")
const modalEndGame = document.querySelector("#js-modal-end-game")

/**
 * game-main-menu.js
 *
 * Handles game main menu with map (panzoom) and pins events
 */
const GameMap = {
	init: () => {
		if (!mapContainer) return
		// init Panzoom
		// let panShow = Panzoom.init(mapContainer)

		// GameMap.bindEvents(panShow)
		GameMap.bindEvents("")
	},

	/**
	 * Ajoute des évènements au load, au clic et au zoom.
	 * @param {Object} panzoomInstance
	 */
	bindEvents: (panzoomInstance) => {
		// Handle map pins
		if (!pinsList.length) return
		document.addEventListener("click", function (e) {
			// open modals
			pinsList.forEach(function (pin) {
				if (pin.contains(e.target)) {
					let modal = document.querySelector(pin.children[0].dataset.openModal)
					GameMap.toggleModal(modal, panzoomInstance)
				}
			})
			// close modals
			if (!closeModalButtons.length) return
			closeModalButtons.forEach(function (button) {
				if (button.contains(e.target) && button.id !== "js-close-menu") {
					let modal = document.querySelector("#" + button.dataset.closeModal)
					GameMap.toggleModal(modal, panzoomInstance)
				}
			})
		})


		// Pins
		if(sessionStorage.getItem("scores") !== null){
			var score_session = JSON.parse(sessionStorage.getItem("scores"));
			for(var profils in score_session){
				document.querySelector(".pin-" + profils + " .map-pin__bubble__score").innerHTML = score_session[profils] + "/10";
				document.querySelector(".pin-" + profils).classList.add("is-success")

				// Couleur en fonction du score
				var classe_score = "score-a";

				if(score_session[profils] < 4)
					classe_score = "score-c"
			
				if(score_session[profils] >= 4 && score_session[profils] < 7)
					classe_score = "score-b"

				document.querySelector(".pin-" + profils).classList.add(classe_score)


			}
		}

		// handle pins scaling at load
		// GameMap.setPinsZoom(1, 0.5)
		/*
		GameMap.setPinsZoom(panzoomInstance.getTransform().scale, panzoomInstance.getMinZoom())
		// handle pins scaling on zoom
		panzoomInstance.on("zoom", function (e) {
			GameMap.setPinsZoom(e.getTransform().scale, panzoomInstance.getMinZoom())
		})
		*/

		// Handle modal end game
		if (Game.isFinished()) {
			// console.log("Le jeu est terminé")

			/*
			if (modalEndGame) {
				GameMap.toggleModal(modalEndGame, panzoomInstance)
			}
			*/
		}
	},

	/**
	 * Set map pins zoom according to map zoomLevel, so pins keep 1:1 ratio
	 * @param {Number} zoomLevel le niveau de zoom actuel de l'instance panzoom
	 * @param {Number} minZoom le minZoom de l'instance panzoom
	 */
	setPinsZoom: (zoomLevel, minZoom) => {
		if (zoomLevel >= minZoom && zoomLevel <= 1) {
			pinsList.forEach((pin) => {
				pin.style.transform = "scale(" + 1 / zoomLevel + ")"
				pin.childNodes[0].style.bottom = 4 / zoomLevel + "px"
			})
		}
	},

	/**
	 * Ouvre / ferme une modal et met en pause/lecture panzoom
	 * @param {HTMLElement} modal Le DOMElement de la modal
	 * @param {Object} panzoomInstance L'instance de PanZoom
	 */
	toggleModal: (modal, panzoomInstance) => {
		if (Modal.isOpen(modal)) {
			if (panzoomInstance && panzoomInstance.isPaused()) {
				panzoomInstance.resume()
			}
			Modal.close(modal)
		} else {
			if (panzoomInstance && !panzoomInstance.isPaused()) {
				panzoomInstance.pause()
			}
			Modal.open(modal)
		}
	},
}

export default GameMap
